'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findService = exports.gallery = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.findComponent = findComponent;
exports.setGallery = setGallery;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _upperFirst = require('lodash/upperFirst');

var _upperFirst2 = _interopRequireDefault(_upperFirst);

var _getComponent = require('../layouts/getComponent');

var _layerConvertor = require('./layerConvertor');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hcGetComponent = _getComponent.getComponent;
var gallery = exports.gallery = {
  layouts: {
    name: 'layout',
    items: {}
  },
  services: {
    name: 'service',
    items: {}
  },
  layers: {
    name: 'layer',
    items: {}
  },
  components: {
    name: 'component',
    items: {
      custom: { name: 'custom', items: {} },
      hc: { name: 'hc', items: {} },
      antd: { name: 'antd', items: {} },
      material: { name: 'material', items: {} }
    }
  }
};

function findComponent() {
  var cname = void 0;
  var componentType = void 0;
  var component = void 0;
  var getComponent = void 0;
  var contextTypes = void 0;
  var hoc = void 0;
  var props = void 0;
  var getProps = void 0;
  var galleryType = void 0;
  var original = void 0;

  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (Object(args[0]) === args[0]) {
    var _args$ = args[0];
    cname = _args$.cname;
    componentType = _args$.componentType;
    component = _args$.component;
    props = _args$.props;
    getProps = _args$.getProps;
    getComponent = _args$.getComponent;
    contextTypes = _args$.contextTypes;
    hoc = _args$.hoc;

    original = args[1];
    galleryType = args[2];
  } else {
    cname = args[0];
    componentType = args[1];
    component = args[2];
    props = args[3];
    getProps = args[4];
    getComponent = args[5];
    contextTypes = args[6];
    hoc = args[7];
    original = args[8];
    galleryType = args[9];
  }
  var decorative = !original;

  var componentList = galleryType ? gallery[galleryType] : gallery.components.items[componentType] || gallery.components.items['custom'];

  var newComponent = void 0;
  var async = void 0;
  if (getComponent) {
    newComponent = _layerConvertor.converter.parse(getComponent);
    async = true;
    newComponent._async = async;
  } else {
    if (typeof component === 'function') {
      // 本身就是组件
      newComponent = component;
    } else if (cname) {
      /**
       * com = {
       *  componentType: [antd|custom|hc|material],
       *  cname: 'x',
       *  props: {
       *    ...
       *  }
       * }
       */
      var cs = cname.split('.');
      newComponent = componentList.items[cs.shift()];
      // Button.Group
      while (newComponent && cs.length) {
        newComponent = newComponent[cs.shift()];
      }
    }
  }

  if (newComponent) {
    var newContextTypes = {};
    if (contextTypes) {
      contextTypes.forEach(function (name) {
        newContextTypes[name] = _propTypes2.default.any;
      });
      if (newComponent.contextTypes) {
        Object.assign(newComponent.contextTypes, newContextTypes);
      } else {
        newComponent.contextTypes = newContextTypes;
      }
    }

    if (decorative) {
      if (async) {
        props = props || {};
      }
      newComponent = hcGetComponent(props, _layerConvertor.converter.parse(getProps))(newComponent);
    }

    // 一般来说和view不能共用
    if (hoc) {
      var Com = findComponent(hoc);
      if (!Com) {
        window.console.log('hoc组件丢失');
      }
      var ChildComponent = newComponent;
      var childProps = hoc.childProps || {};

      var HocComponent = function (_React$PureComponent) {
        _inherits(HocComponent, _React$PureComponent);

        function HocComponent() {
          _classCallCheck(this, HocComponent);

          return _possibleConstructorReturn(this, (HocComponent.__proto__ || Object.getPrototypeOf(HocComponent)).apply(this, arguments));
        }

        _createClass(HocComponent, [{
          key: 'render',
          value: function render() {
            var children = _react2.default.createElement(
              Com,
              null,
              _react2.default.createElement(newComponent.ChildComponent, _extends({}, childProps, this.props))
            );
            // #! 包裹
            var wrapper = _layerConvertor.converter.parse(hoc.wrapper);
            if (wrapper) {
              return wrapper(children);
            } else {
              return children;
            }
          }
        }]);

        return HocComponent;
      }(_react2.default.PureComponent);

      newComponent = HocComponent;
      newComponent.ChildComponent = ChildComponent;
      newComponent._async = ChildComponent._async;
    }
  }
  return newComponent;
}

var findService = exports.findService = function findService(name) {
  return gallery.services.items[name];
};

function setGallery(aGallery) {
  for (var key in aGallery) {
    if (key === 'components') {
      for (var ikey in aGallery[key]) {
        window[(0, _upperFirst2.default)(ikey)] = aGallery[key][ikey];
        Object.assign(gallery[key].items[ikey].items, aGallery[key][ikey]);
      }
    } else {
      Object.assign(gallery[key].items, aGallery[key]);
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/layers/galleryResolver.js
// module id = 15
// module chunks = 0